import { borderColorSeparate, FreshAsphalt, FreshAsphalt50 } from './palette';

export const pageAuthBorderColor = borderColorSeparate;
export const pageAuthTextColor = FreshAsphalt;
export const pageAuthTextColorSecondary = FreshAsphalt50;
